import { ILookUpType, IModelMapping, IProductType, IProductTypeModel } from "lib-core-shared";

export class ProductTypeDtoMapping implements IModelMapping<IProductTypeModel, IProductType> {
    toApplicationModel(model: IProductTypeModel): IProductType {
        let productType = {
            code: model.code,
            deleted: false,
            sortOrder: 0,
            titles: model.translations
        } as IProductType;
        return productType;
    }
    toDtoModel(model: IProductType): IProductTypeModel {
        return {
            id: '', 
            code: model.code,
            translations:model.titles,
            displayText: model.titles.length ? model.titles[0].title: ''
        } as IProductTypeModel;
    }
    toDtoModels(models: IProductType[]): IProductTypeModel[] {
        throw new Error("Method not implemented.");
    }
    toApplicationModels(models: IProductTypeModel[]): IProductType[] {
        throw new Error("Method not implemented.");
    }
    // toApplicationModel(model: IProductTypeModel): ILookUpType {
    //    return {
    //         name: model?.translations?.length ? model.translations[0].title: '',
    //         title: '',
    //         code:  model?.translations?.length ? model.translations[0].productTypeCode: '',
    //     }
    // }
    // toDtoModel(model: ILookUpType): IProductTypeModel {
    //     throw new Error("Method not implemented.");
    // }
    // toDtoModels(models: ILookUpType[]): IProductTypeModel[] {
    //     throw new Error("Method not implemented.");
    // }
    // toApplicationModels(models: IProductTypeModel[]): ILookUpType[] {
    //     throw new Error("Method not implemented.");
    // }
}